module.exports = __webpack_public_path__ + "static/media/sdg12.5f7c2f33.png";